export const DEFAULT_ZOOM = 10;
